import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { flagUrl } from '../utils/currencies';

const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: 'fr' },
  { code: 'en', name: 'English', flag: 'gb' },
  { code: 'es', name: 'Español', flag: 'es' },
  { code: 'pt', name: 'Português', flag: 'pt' },
  { code: 'de', name: 'Deutsch', flag: 'de' },
  { code: 'ru', name: 'Русский', flag: 'ru' },
];

const LanguageSelector = ({ dark = false }) => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currentLang = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center space-x-2 px-3 py-2 rounded-full transition-colors ${dark ? 'hover:bg-white/10 text-white/80' : 'hover:bg-gray-100 text-gray-600'}`}
        data-testid="language-selector">
        <img src={flagUrl(currentLang.flag)} alt={currentLang.code} className="w-5 h-5 rounded-full" />
        <span className="text-sm font-semibold uppercase">{language}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-2xl border border-gray-100 py-1.5 z-50 shadow-[0_16px_48px_rgb(0,0,0,0.12)]">
          {LANGUAGES.map((lang) => (
            <button key={lang.code} onClick={() => { changeLanguage(lang.code); setIsOpen(false); }}
              className={`w-full px-4 py-2.5 text-left hover:bg-gray-50 transition-colors flex items-center space-x-3 ${language === lang.code ? 'bg-gray-50' : ''}`}
              data-testid={`lang-${lang.code}`}>
              <img src={flagUrl(lang.flag)} alt={lang.code} className="w-5 h-5 rounded-full" />
              <span className={`text-sm ${language === lang.code ? 'text-gray-900 font-semibold' : 'text-gray-600'}`}>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
